/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getWebLoginConfigInternal} from '../api'

 export const useQueryGetWebLoginConfigInternal = createReactQueryHook('getWebLoginConfigInternal', getWebLoginConfigInternal)
